export async function getLatestAppVersion(): Promise<string> {
  const response = await fetch('/version.json', { cache: 'no-store' })
  if (!response.ok) {
    throw new Error('Failed to fetch latest app version')
  }
  const data = await response.json()
  return data.commit
}
